import { render, staticRenderFns } from "./FText.vue?vue&type=template&id=5ca5d5ea&"
import script from "./FText.vue?vue&type=script&lang=js&"
export * from "./FText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports